import { render, staticRenderFns } from "./CompanyModal.vue?vue&type=template&id=04a64168"
import script from "./CompanyModal.vue?vue&type=script&lang=js"
export * from "./CompanyModal.vue?vue&type=script&lang=js"
import style0 from "./CompanyModal.vue?vue&type=style&index=0&id=04a64168&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports